var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operation-log" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c(
              "el-form",
              {
                ref: "queryForm",
                attrs: {
                  model: _vm.queryParams,
                  "label-width": "100px",
                  size: "small",
                  inline: "",
                },
              },
              [
                _c("div", { staticClass: "filter-form" }, [
                  _c(
                    "div",
                    { staticClass: "filter-default" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "操作来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: {
                                placeholder: "请选择操作来源",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.operation_source,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "operation_source",
                                    $$v
                                  )
                                },
                                expression: "queryParams.operation_source",
                              },
                            },
                            _vm._l(_vm.sourceOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "操作时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "|",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "操作菜单" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入操作菜单关键字",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.operation_menu,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "operation_menu", $$v)
                              },
                              expression: "queryParams.operation_menu",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "操作类型" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              placeholder: "请输入操作类型关键字",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.operation_option,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "operation_option",
                                  $$v
                                )
                              },
                              expression: "queryParams.operation_option",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-buttons" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.handleFilter },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-refresh" },
                              on: { click: _vm.resetQuery },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.logList, border: "", height: 600 },
                on: { "row-click": _vm.handleView },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "id",
                    label: "ID",
                    width: "80",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作来源", width: "120", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getSourceTagType(
                                  scope.row.operation_source
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    scope.row.operation_source_text ||
                                      _vm.getSourceText(
                                        scope.row.operation_source
                                      )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作菜单",
                    width: "200",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.operation_menu || "-")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作类型",
                    width: "150",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.operation_option || "-")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作内容",
                    "min-width": "300",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.content || "-")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "埋点ID",
                    width: "180",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.operation_id
                            ? _c(
                                "el-tag",
                                { attrs: { type: "info", size: "mini" } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.operation_id) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "user_nick_name",
                    label: "操作用户",
                    width: "150",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "create_time",
                    label: "操作时间",
                    width: "180",
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作日志详情",
            visible: _vm.dialogVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "detail-form",
              attrs: { model: _vm.currentLog, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "ID" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.currentLog.id))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "操作来源" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getSourceTagType(
                                  _vm.currentLog.operation_source
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.currentLog.operation_source_text ||
                                      _vm.getSourceText(
                                        _vm.currentLog.operation_source
                                      )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "操作路径" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentLog.opration_path || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "操作菜单" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentLog.operation_menu || "-")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "操作类型" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.currentLog.operation_option || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "埋点ID" } },
                        [
                          _vm.currentLog.operation_id
                            ? _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.currentLog.operation_id) +
                                    "\n            "
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "操作用户" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentLog.user_nick_name || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "操作时间" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentLog.create_time || "-")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "操作内容" } }, [
                        _c("div", { staticClass: "content-box" }, [
                          _vm._v(_vm._s(_vm.currentLog.content || "-")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }